import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL
/*
import { AbilityBuilder, Ability } from '@casl/ability'
const ability = new Ability()

const ability = new Ability([])

function defineRulesFor(user) {
  const { can, rules } = AbilityBuilder.extract()
  
  can(['read'], 'all', { username: user.email })

  return rules
}
*/
let vm = new Vue();

const store = new Vuex.Store({
  state: {
    token: localStorage.getItem('access_token') || null,
    user: {},
    token_valid: localStorage.getItem('access_token') ? true : false,
    cart: [],
    loadingStack: 0,
    urlProfilePhoto: 'img/theme/team-4.jpg'
  },
  getters: {
    isLoggedIn(state) {
      return state.token !== null
    },
    isUserLoaded(state)
    {
      return !Object.entries(state.user)
    },
    isLoggedExpirated(state) {
      return !state.token_valid
    },
    cartLength(state)
    {
      return state.cart.length || 0
    }
  },
  mutations: {
    retrieveToken(state, token) {
      state.token = token
    },
    destroyToken(state) {
      state.token = null
    },
    retrieveUser(state, data) {
      state.user = data
    },
    retrieveCart(state, data){
      state.cart = data 
    },
    incrementLoadingStack(state){
      state.loadingStack++;
    },
    decrementLoadingStack(state){
      state.loadingStack--;
    },
    refreshProfilePhoto(state, url){
      state.urlProfilePhoto = url
    }
  },
  actions: {
    retrieveCart(context){
      Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.isLoggedIn){
        return new Promise((resolve, reject) => {
          Vue.axios.get('/api/fetch-cart')
          .then( response => {
            context.commit('retrieveCart', response.data);
            resolve(response.data);
          })
          .catch( error => {
            console.log(error);
            reject(error)
          });
        });
      }
    },
    retrieveToken(context, credentials) {
      // credentials: {username: ..., password: ..., vm: Vue instance}
      return new Promise((resolve, reject) => {
        Vue.axios.post('/api/login', {
          username: credentials.username,
          password: credentials.password,
        })
        .then(response => {
          //console.log(response)
          const token = response.data.access_token
          localStorage.setItem('access_token', token)
          context.commit('retrieveToken', token)
          
          resolve(response)
        })
        .catch(error => {
          
          reject(error)
        })
      })

    },
    destroyToken(context) {

      Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token
      
      if (context.getters.isLoggedIn){
        
        return new Promise((resolve, reject) => {
          Vue.axios.post('/api/logout')
            .then(response => {
              //console.log(response)
              localStorage.removeItem('access_token')
              context.commit('destroyToken')
  
              resolve(response)
            })
            .catch(error => {
              //console.log(error)
              localStorage.removeItem('access_token')
              context.commit('destroyToken')

              reject(error)
            })
        })

      }
    },
    retrieveUser(context){
        
        Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token
        if (context.getters.isLoggedIn){
          return new Promise((resolve, reject) => {
            Vue.axios.get('/api/user')
              .then(response => {
                context.commit('retrieveUser', { 
                  email: response.data.email, 
                  name: response.data.name, 
                  permissions: response.data.permissions,
                  sponsor: response.data.sponsor,
                  sponsor_branch: response.data.sponsor_branch,
                  team: response.data.team,
                  address: response.data.address,
                  region: response.data.region,
                  comuna: response.data.comuna,
                  about_me: response.data.about_me,
                  zip_code: response.data.zip_code,
                  pais_sponsor: response.data.pais_sponsor,
                });
                context.commit('refreshProfilePhoto', response.data.profile_image_url);
                let arreglo = [];
                response.data.permissions.forEach(element => {
                    arreglo.push({subject: element[1], actions: element[0]});
                });
                console.log(arreglo);
                vm.$ability.update(arreglo);
                resolve(response.data);
              })
              .catch( error => {
                console.log(error);
                context.commit('destroyToken');
                reject(error)
              })
          })
        }
      },
      checkTokenExpiration(context){

      }
    }
  })

export default store